var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "45 95 200 60",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "06c6e33226"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 267.703125 167.3125 L 268.601562 167.3125 L 268.601562 194.601562 L 267.703125 194.601562 Z M 47.09375 194.601562 L 268.601562 194.601562 L 268.601562 195.5 L 47.09375 195.5 Z M 47.09375 194.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "95bd8ca173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.648438 158.105469 L 263.351562 158.105469 L 263.351562 159.054688 L 36.648438 159.054688 Z M 262.378906 159.054688 L 263.351562 159.054688 L 263.351562 188.800781 L 262.378906 188.800781 Z M 36.648438 159.054688 L 37.601562 159.054688 L 37.601562 188.800781 L 36.648438 188.800781 Z M 36.648438 188.800781 L 263.351562 188.800781 L 263.351562 189.773438 L 36.648438 189.773438 Z M 36.648438 188.800781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "024fccff3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.3125 104.496094 L 207.3125 104.496094 L 207.3125 152.496094 L 159.3125 152.496094 Z M 159.3125 104.496094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad6e75cb31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.3125 113.066406 L 159.3125 143.925781 C 159.3125 148.660156 163.148438 152.496094 167.882812 152.496094 C 176.265625 152.496094 190.359375 152.496094 198.742188 152.496094 C 201.015625 152.496094 203.195312 151.59375 204.800781 149.984375 C 206.410156 148.378906 207.3125 146.199219 207.3125 143.925781 L 207.3125 113.066406 C 207.3125 110.792969 206.410156 108.613281 204.800781 107.007812 C 203.195312 105.398438 201.015625 104.496094 198.742188 104.496094 L 167.882812 104.496094 C 163.148438 104.496094 159.3125 108.332031 159.3125 113.066406 Z M 162.742188 143.925781 L 162.742188 113.066406 C 162.742188 110.226562 165.042969 107.925781 167.882812 107.925781 L 198.742188 107.925781 C 200.105469 107.925781 201.414062 108.464844 202.378906 109.429688 C 203.34375 110.394531 203.882812 111.703125 203.882812 113.066406 L 203.882812 143.925781 C 203.882812 145.289062 203.34375 146.597656 202.378906 147.5625 C 201.414062 148.527344 200.105469 149.066406 198.742188 149.066406 C 190.359375 149.066406 176.265625 149.066406 167.882812 149.066406 C 165.042969 149.066406 162.742188 146.765625 162.742188 143.925781 Z M 182.453125 134.496094 C 182.453125 131.65625 180.152344 129.351562 177.3125 129.351562 L 170.453125 129.351562 C 167.613281 129.351562 165.3125 131.65625 165.3125 134.496094 L 165.3125 141.351562 C 165.3125 144.195312 167.613281 146.496094 170.453125 146.496094 L 177.3125 146.496094 C 180.152344 146.496094 182.453125 144.195312 182.453125 141.351562 Z M 191.027344 136.210938 L 185.882812 136.210938 C 184.9375 136.210938 184.167969 136.976562 184.167969 137.925781 C 184.167969 138.871094 184.9375 139.640625 185.882812 139.640625 L 191.027344 139.640625 L 191.027344 144.78125 C 191.027344 145.726562 191.792969 146.496094 192.742188 146.496094 C 193.6875 146.496094 194.453125 145.726562 194.453125 144.78125 L 194.453125 139.640625 L 199.597656 139.640625 C 200.542969 139.640625 201.3125 138.871094 201.3125 137.925781 C 201.3125 136.976562 200.542969 136.210938 199.597656 136.210938 L 194.453125 136.210938 L 194.453125 131.066406 C 194.453125 130.121094 193.6875 129.351562 192.742188 129.351562 C 191.792969 129.351562 191.027344 130.121094 191.027344 131.066406 Z M 179.027344 134.496094 L 179.027344 141.351562 C 179.027344 142.300781 178.257812 143.066406 177.3125 143.066406 C 177.3125 143.066406 170.453125 143.066406 170.453125 143.066406 C 169.507812 143.066406 168.742188 142.300781 168.742188 141.351562 C 168.742188 141.351562 168.742188 134.496094 168.742188 134.496094 C 168.742188 133.546875 169.507812 132.78125 170.453125 132.78125 C 170.453125 132.78125 177.3125 132.78125 177.3125 132.78125 C 178.257812 132.78125 179.027344 133.546875 179.027344 134.496094 Z M 182.453125 115.640625 C 182.453125 112.796875 180.152344 110.496094 177.3125 110.496094 L 170.453125 110.496094 C 167.613281 110.496094 165.3125 112.796875 165.3125 115.640625 L 165.3125 122.496094 C 165.3125 125.335938 167.613281 127.640625 170.453125 127.640625 L 177.3125 127.640625 C 180.152344 127.640625 182.453125 125.335938 182.453125 122.496094 Z M 201.3125 115.640625 C 201.3125 112.796875 199.011719 110.496094 196.167969 110.496094 L 189.3125 110.496094 C 186.472656 110.496094 184.167969 112.796875 184.167969 115.640625 L 184.167969 122.496094 C 184.167969 125.335938 186.472656 127.640625 189.3125 127.640625 L 196.167969 127.640625 C 199.011719 127.640625 201.3125 125.335938 201.3125 122.496094 Z M 179.027344 115.640625 L 179.027344 122.496094 C 179.027344 123.441406 178.257812 124.210938 177.3125 124.210938 C 177.3125 124.210938 170.453125 124.210938 170.453125 124.210938 C 169.507812 124.210938 168.742188 123.441406 168.742188 122.496094 C 168.742188 122.496094 168.742188 115.640625 168.742188 115.640625 C 168.742188 114.691406 169.507812 113.925781 170.453125 113.925781 C 170.453125 113.925781 177.3125 113.925781 177.3125 113.925781 C 178.257812 113.925781 179.027344 114.691406 179.027344 115.640625 Z M 197.882812 115.640625 L 197.882812 122.496094 C 197.882812 123.441406 197.117188 124.210938 196.167969 124.210938 C 196.167969 124.210938 189.3125 124.210938 189.3125 124.210938 C 188.363281 124.210938 187.597656 123.441406 187.597656 122.496094 C 187.597656 122.496094 187.597656 115.640625 187.597656 115.640625 C 187.597656 114.691406 188.363281 113.925781 189.3125 113.925781 C 189.3125 113.925781 196.167969 113.925781 196.167969 113.925781 C 197.117188 113.925781 197.882812 114.691406 197.882812 115.640625 Z M 197.882812 115.640625 ",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.0624998,
    gradientTransform: "matrix(54.857145, 0, 0, 54.857145, 155.883606, 128.495885)",
    y1: 0,
    x2: 0.9375,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "cea40d1c68"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.937073%, 15.324402%, 99.624634%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.169006%, 15.391541%, 99.62616%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.40094%, 15.458679%, 99.627686%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.631348%, 15.525818%, 99.627686%)",
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.863281%, 15.592957%, 99.629211%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.095215%, 15.658569%, 99.630737%)",
    offset: 0.0195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.327148%, 15.725708%, 99.632263%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.559082%, 15.792847%, 99.633789%)",
    offset: 0.0273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.791016%, 15.859985%, 99.635315%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.021423%, 15.927124%, 99.636841%)",
    offset: 0.0351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.253357%, 15.994263%, 99.638367%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.485291%, 16.061401%, 99.638367%)",
    offset: 0.0429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.717224%, 16.12854%, 99.639893%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.949158%, 16.195679%, 99.641418%)",
    offset: 0.0507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.181091%, 16.262817%, 99.642944%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.413025%, 16.32843%, 99.64447%)",
    offset: 0.0585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.644958%, 16.395569%, 99.645996%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.875366%, 16.462708%, 99.647522%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.1073%, 16.529846%, 99.649048%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.339233%, 16.596985%, 99.650574%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.571167%, 16.664124%, 99.6521%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.803101%, 16.731262%, 99.6521%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.035034%, 16.798401%, 99.653625%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.266968%, 16.86554%, 99.655151%)",
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.498901%, 16.932678%, 99.656677%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.729309%, 16.998291%, 99.658203%)",
    offset: 0.0976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.961243%, 17.06543%, 99.659729%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.193176%, 17.132568%, 99.661255%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.42511%, 17.199707%, 99.662781%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.657043%, 17.266846%, 99.664307%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.888977%, 17.333984%, 99.665833%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.120911%, 17.401123%, 99.665833%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.352844%, 17.468262%, 99.667358%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.583252%, 17.5354%, 99.668884%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.815186%, 17.602539%, 99.67041%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.047119%, 17.668152%, 99.671936%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.279053%, 17.735291%, 99.673462%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.510986%, 17.802429%, 99.674988%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.74292%, 17.869568%, 99.676514%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.974854%, 17.936707%, 99.67804%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.206787%, 18.003845%, 99.679565%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.437195%, 18.070984%, 99.679565%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.669128%, 18.138123%, 99.681091%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.901062%, 18.205261%, 99.682617%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.132996%, 18.2724%, 99.684143%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.364929%, 18.338013%, 99.685669%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.596863%, 18.405151%, 99.687195%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.828796%, 18.47229%, 99.688721%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.06073%, 18.539429%, 99.690247%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.291138%, 18.606567%, 99.691772%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.523071%, 18.673706%, 99.693298%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.755005%, 18.740845%, 99.693298%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.986938%, 18.807983%, 99.694824%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.218872%, 18.875122%, 99.69635%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.450806%, 18.942261%, 99.697876%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.682739%, 19.009399%, 99.699402%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.914673%, 19.076538%, 99.700928%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.145081%, 19.142151%, 99.702454%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.377014%, 19.20929%, 99.703979%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.608948%, 19.276428%, 99.703979%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.840881%, 19.343567%, 99.705505%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.072815%, 19.410706%, 99.707031%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.304749%, 19.477844%, 99.708557%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.536682%, 19.544983%, 99.710083%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.768616%, 19.612122%, 99.711609%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.999023%, 19.67926%, 99.713135%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.230957%, 19.746399%, 99.714661%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.462891%, 19.812012%, 99.716187%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.694824%, 19.87915%, 99.717712%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.926758%, 19.946289%, 99.717712%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.158691%, 20.013428%, 99.719238%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.390625%, 20.080566%, 99.720764%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.622559%, 20.147705%, 99.72229%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.852966%, 20.214844%, 99.723816%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.0849%, 20.281982%, 99.725342%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.316833%, 20.349121%, 99.726868%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.548767%, 20.41626%, 99.728394%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.780701%, 20.481873%, 99.729919%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.012634%, 20.549011%, 99.731445%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.244568%, 20.61615%, 99.731445%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.476501%, 20.683289%, 99.732971%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.706909%, 20.750427%, 99.734497%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.938843%, 20.817566%, 99.736023%)",
    offset: 0.320313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.170776%, 20.884705%, 99.737549%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.40271%, 20.951843%, 99.739075%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.634644%, 21.018982%, 99.740601%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.866577%, 21.086121%, 99.742126%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.098511%, 21.151733%, 99.743652%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.330444%, 21.218872%, 99.745178%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.560852%, 21.286011%, 99.745178%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.792786%, 21.353149%, 99.746704%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.024719%, 21.420288%, 99.74823%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.256653%, 21.487427%, 99.749756%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.488586%, 21.554565%, 99.751282%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.72052%, 21.621704%, 99.752808%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.950928%, 21.688843%, 99.754333%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.182861%, 21.755981%, 99.755859%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.414795%, 21.821594%, 99.757385%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.646729%, 21.888733%, 99.758911%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.878662%, 21.955872%, 99.758911%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.110596%, 22.02301%, 99.760437%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.342529%, 22.090149%, 99.761963%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.574463%, 22.157288%, 99.763489%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.804871%, 22.224426%, 99.765015%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.036804%, 22.291565%, 99.766541%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.268738%, 22.358704%, 99.768066%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.500671%, 22.425842%, 99.769592%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.732605%, 22.492981%, 99.771118%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.964539%, 22.56012%, 99.772644%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.196472%, 22.625732%, 99.772644%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.428406%, 22.692871%, 99.77417%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.658813%, 22.76001%, 99.775696%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.890747%, 22.827148%, 99.777222%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.122681%, 22.894287%, 99.778748%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.354614%, 22.961426%, 99.780273%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.586548%, 23.028564%, 99.781799%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.818481%, 23.095703%, 99.783325%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.050415%, 23.162842%, 99.783325%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.282349%, 23.22998%, 99.784851%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.512756%, 23.295593%, 99.786377%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.74469%, 23.362732%, 99.787903%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.976624%, 23.429871%, 99.789429%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.208557%, 23.497009%, 99.790955%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.440491%, 23.564148%, 99.79248%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.672424%, 23.631287%, 99.794006%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.904358%, 23.698425%, 99.795532%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.136292%, 23.765564%, 99.797058%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.366699%, 23.832703%, 99.797058%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.598633%, 23.899841%, 99.798584%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.830566%, 23.965454%, 99.80011%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.0625%, 24.032593%, 99.801636%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.294434%, 24.099731%, 99.803162%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.526367%, 24.16687%, 99.804688%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.758301%, 24.234009%, 99.806213%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.990234%, 24.301147%, 99.807739%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.220642%, 24.368286%, 99.809265%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.452576%, 24.435425%, 99.810791%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.684509%, 24.502563%, 99.810791%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.916443%, 24.569702%, 99.812317%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.148376%, 24.635315%, 99.813843%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.38031%, 24.702454%, 99.815369%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.612244%, 24.769592%, 99.816895%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.844177%, 24.836731%, 99.81842%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.074585%, 24.90387%, 99.819946%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.306519%, 24.971008%, 99.821472%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.538452%, 25.038147%, 99.822998%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.770386%, 25.105286%, 99.824524%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.002319%, 25.172424%, 99.824524%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.234253%, 25.239563%, 99.82605%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.466187%, 25.305176%, 99.827576%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.69812%, 25.372314%, 99.829102%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.928528%, 25.439453%, 99.830627%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.160461%, 25.506592%, 99.832153%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.392395%, 25.57373%, 99.833679%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.624329%, 25.640869%, 99.835205%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.856262%, 25.708008%, 99.836731%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.088196%, 25.775146%, 99.838257%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.320129%, 25.842285%, 99.838257%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.552063%, 25.909424%, 99.839783%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.782471%, 25.976562%, 99.841309%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.014404%, 26.043701%, 99.842834%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.246338%, 26.109314%, 99.84436%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.478271%, 26.176453%, 99.845886%)",
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.710205%, 26.243591%, 99.847412%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.942139%, 26.31073%, 99.848938%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.174072%, 26.377869%, 99.848938%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.406006%, 26.445007%, 99.850464%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.636414%, 26.512146%, 99.85199%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.868347%, 26.579285%, 99.853516%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.100281%, 26.646423%, 99.855042%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.332214%, 26.713562%, 99.856567%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.564148%, 26.779175%, 99.858093%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.796082%, 26.846313%, 99.859619%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.026489%, 26.913452%, 99.861145%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.258423%, 26.980591%, 99.862671%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.490356%, 27.047729%, 99.862671%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.72229%, 27.114868%, 99.864197%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.954224%, 27.182007%, 99.865723%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.186157%, 27.249146%, 99.867249%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.418091%, 27.316284%, 99.868774%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.650024%, 27.383423%, 99.8703%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.880432%, 27.449036%, 99.871826%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.112366%, 27.516174%, 99.873352%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.344299%, 27.583313%, 99.874878%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.576233%, 27.650452%, 99.876404%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.808167%, 27.71759%, 99.876404%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.0401%, 27.784729%, 99.87793%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.272034%, 27.851868%, 99.879456%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.503967%, 27.919006%, 99.880981%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.734375%, 27.986145%, 99.882507%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.966309%, 28.053284%, 99.884033%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.198242%, 28.118896%, 99.885559%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.430176%, 28.186035%, 99.887085%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.662109%, 28.253174%, 99.888611%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.894043%, 28.320312%, 99.890137%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.125977%, 28.387451%, 99.890137%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.35791%, 28.45459%, 99.891663%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.588318%, 28.521729%, 99.893188%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.820251%, 28.588867%, 99.894714%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.052185%, 28.656006%, 99.89624%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.284119%, 28.723145%, 99.897766%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.516052%, 28.788757%, 99.899292%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.747986%, 28.855896%, 99.900818%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.979919%, 28.923035%, 99.902344%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.211853%, 28.990173%, 99.90387%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.442261%, 29.057312%, 99.90387%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.674194%, 29.124451%, 99.905396%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.906128%, 29.191589%, 99.906921%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.138062%, 29.258728%, 99.908447%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.369995%, 29.325867%, 99.909973%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.601929%, 29.393005%, 99.911499%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.833862%, 29.460144%, 99.913025%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.065796%, 29.527283%, 99.914551%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.296204%, 29.592896%, 99.914551%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.528137%, 29.660034%, 99.916077%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.760071%, 29.727173%, 99.917603%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.992004%, 29.794312%, 99.919128%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.223938%, 29.86145%, 99.920654%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.455872%, 29.928589%, 99.92218%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.687805%, 29.995728%, 99.923706%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.919739%, 30.062866%, 99.925232%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.150146%, 30.130005%, 99.926758%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.38208%, 30.197144%, 99.928284%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.614014%, 30.262756%, 99.928284%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.845947%, 30.329895%, 99.92981%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.077881%, 30.397034%, 99.931335%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.309814%, 30.464172%, 99.932861%)",
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.541748%, 30.531311%, 99.934387%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.773682%, 30.59845%, 99.935913%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.004089%, 30.665588%, 99.937439%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.236023%, 30.732727%, 99.938965%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.467957%, 30.799866%, 99.940491%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.69989%, 30.867004%, 99.942017%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.931824%, 30.932617%, 99.942017%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.163757%, 30.999756%, 99.943542%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.395691%, 31.066895%, 99.945068%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.627625%, 31.134033%, 99.946594%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.858032%, 31.201172%, 99.94812%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.089966%, 31.268311%, 99.949646%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.321899%, 31.335449%, 99.951172%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.553833%, 31.402588%, 99.952698%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.785767%, 31.469727%, 99.954224%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.0177%, 31.536865%, 99.95575%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.249634%, 31.602478%, 99.95575%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.481567%, 31.669617%, 99.957275%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.711975%, 31.736755%, 99.958801%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.943909%, 31.803894%, 99.960327%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.175842%, 31.871033%, 99.961853%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.407776%, 31.938171%, 99.963379%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.639709%, 32.00531%, 99.964905%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.871643%, 32.072449%, 99.966431%)",
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.103577%, 32.139587%, 99.967957%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.33551%, 32.206726%, 99.969482%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.565918%, 32.273865%, 99.969482%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.797852%, 32.341003%, 99.971008%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.029785%, 32.406616%, 99.972534%)",
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.261719%, 32.473755%, 99.97406%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#024fccff3d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad6e75cb31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cea40d1c68)",
    d: "M 159.3125 104.496094 L 159.3125 152.496094 L 207.3125 152.496094 L 207.3125 104.496094 Z M 159.3125 104.496094 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#050a30",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.446515, 178.681819)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#050a30",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.293806, 143.970631)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.125 -20.859375 L 18.921875 -20.859375 L 18.921875 -19.515625 L 18.328125 -18.921875 L 5.0625 -18.921875 L 5.0625 -10.734375 L 15.640625 -10.734375 L 15.640625 -8.796875 L 5.0625 -8.796875 L 5.0625 0 L 3.125 0 Z M 3.125 -20.859375 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#050a30",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.706126, 143.970631)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.125 -20.859375 L 5.0625 -20.859375 L 5.0625 0 L 3.125 0 Z M 3.125 -20.859375 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#050a30",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.645829, 143.970631)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.640625 -18.921875 L 0.59375 -18.921875 L 0.59375 -20.859375 L 18.625 -20.859375 L 18.625 -19.515625 L 18.03125 -18.921875 L 10.578125 -18.921875 L 10.578125 0 L 8.640625 0 Z M 8.640625 -18.921875 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#050a30",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.390948, 143.505017)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.28125 -21.890625 L 5.3125 -21.890625 L 5.3125 -2.03125 L 19.703125 -2.03125 L 19.703125 0 L 3.28125 0 Z M 3.28125 -21.890625 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#050a30",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.663751, 143.505017)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.28125 -21.890625 L 20.015625 -21.890625 L 20.015625 -20.484375 L 19.390625 -19.859375 L 5.3125 -19.859375 L 5.3125 -12.203125 L 16.734375 -12.203125 L 16.734375 -10.171875 L 5.3125 -10.171875 L 5.3125 -2.03125 L 20.015625 -2.03125 L 20.015625 0 L 3.28125 0 Z M 3.28125 -21.890625 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#050a30",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.875045, 143.505017)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.65625 0 C 6.15625 0 4.945312 -0.457031 4.03125 -1.375 C 3.113281 -2.289062 2.65625 -3.5 2.65625 -5 L 2.65625 -16.890625 C 2.65625 -18.390625 3.113281 -19.597656 4.03125 -20.515625 C 4.945312 -21.429688 6.15625 -21.890625 7.65625 -21.890625 L 20.328125 -21.890625 L 20.328125 -20.484375 L 19.703125 -19.859375 L 7.8125 -19.859375 C 5.726562 -19.859375 4.6875 -18.816406 4.6875 -16.734375 L 4.6875 -5.15625 C 4.6875 -3.070312 5.726562 -2.03125 7.8125 -2.03125 L 19.546875 -2.03125 L 19.546875 -11.734375 L 21.578125 -11.734375 L 21.578125 0 Z M 7.65625 0 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#050a30",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.214636, 143.505017)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.625 -1.09375 L 10.015625 -21.890625 L 12.515625 -21.890625 L 21.890625 -1.09375 L 21.890625 0 L 20.015625 0 L 17.515625 -5.625 L 5 -5.625 L 2.5 0 L 0.625 0 Z M 16.734375 -7.65625 L 11.265625 -20.015625 L 5.78125 -7.65625 Z M 16.734375 -7.65625 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#050a30",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.520837, 143.505017)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.28125 -21.890625 L 5.3125 -21.890625 L 5.3125 -2.03125 L 19.703125 -2.03125 L 19.703125 0 L 3.28125 0 Z M 3.28125 -21.890625 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.48a0092952721e7ce468de6692515073.svg";
export { ForwardRef as ReactComponent };